import { render, staticRenderFns } from "./HomeTypes.vue?vue&type=template&id=79bcf0a4&"
import script from "./HomeTypes.vue?vue&type=script&lang=js&"
export * from "./HomeTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomeTypes.vue"
export default component.exports